import React from 'react';
import { FormikProvider } from 'formik';

import { renderNode } from '../../helpers';
import { EnhancedFormikProps } from './types';
import useEnhancedFormik from './useEnhancedFormik';

export default function EnhancedFormik({ children, ...formikConfig }) {
    const formik = useEnhancedFormik(formikConfig);

    return <FormikProvider value={formik}>{renderNode(children, formik)}</FormikProvider>;
}

EnhancedFormik.propTypes = EnhancedFormikProps;
